import { render } from "./Project_count.vue?vue&type=template&id=61565459&scoped=true"
import script from "./Project_count.vue?vue&type=script&lang=js"
export * from "./Project_count.vue?vue&type=script&lang=js"

import "./Project_count.vue?vue&type=style&index=0&id=61565459&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61565459"]])

export default __exports__